import isPlainObject from 'lodash/isPlainObject';
import { formValueSelector } from 'redux-form';
import { authorization } from 'apex-legit-service';
import { createSelector } from 'reselect';
import {
  LOADING as DETAILS_SERVICE_LOADING,
  selectStatus as selectDetailsServiceStatus,
  selectResult,
} from 'services/details';
import {
  FAILURE as UPDATE_WIRE_SERVICE_FAILURE,
  selectStatus,
} from 'services/updateWire';

export const selectIsDetailsServiceLoading = createSelector(
  selectDetailsServiceStatus,
  (results) => results === DETAILS_SERVICE_LOADING
);

/**
 * Select whether a transfer amount can be edited by the current user.
 *
 * Returns true when the transfer user action updateAmount returns true.
 *
 * @returns {boolean}
 */
export const selectShouldAllowEditAmount = (state, ownProps) => {
  const searchResult = selectResult(state, ownProps);
  const canUpdateAmount = isPlainObject(searchResult) && searchResult.updateAmount;
  if (!canUpdateAmount) return false;
  return canUpdateAmount;
};

export const selectShowAllFields = (state) => {
  const domain = state[authorization.NAMESPACE];
  const { results: { permissions } } = domain;
  const permissionNeeded = 'sentinel2.evaluatedTransfersFull.list';
  return permissions.some(({ permitted, request: { permission } }) => permission === permissionNeeded && permitted); //bool
};

/**
 * Select whether a transfer account can be edited by the current user.
 *
 * Returns true when the transfer state is ReviewPending or Suspended
 * and it is an incoming wire.
 *
 * @returns {boolean}
 */

export const selectUpdateWireFailure = createSelector(
  selectStatus,
  (result) => result === UPDATE_WIRE_SERVICE_FAILURE
);

export const accountFormSelector = (state) => {
  const selector = formValueSelector('UpdateAccount');
  return selector(state, 'updatedAccount');
};



// WEBPACK FOOTER //
// ./src/containers/Details/selectors.js